import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getMySummaryFeedbackApi = ({ limit = 3, offset = 0, employeeId }) => {
  const url = endpoints.home.mySummary.feedback(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
    },
  });
};
